module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    ref: "trigger"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    ref: "popover",
    staticClass: "popover fade",
    class: [_vm.classState ? 'show' : '', _vm.popoverAlignment],
    style: (_vm.popoverStyle),
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "focus": function($event) {
        _vm.$emit('focus')
      },
      "blur": function($event) {
        _vm.$emit('blur')
      }
    }
  }, [_c('div', {
    staticClass: "popover-arrow"
  }), _vm._v(" "), (_vm.title) ? _c('h3', {
    staticClass: "popover-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popover-content"
  }, [_c('div', {
    staticClass: "popover-content-wrapper"
  }, [_vm._t("content", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbaf97d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/popover.vue
// module id = 260
// module chunks = 0